// extracted by mini-css-extract-plugin
module.exports = {"profileAddressCurrent":"CurrentAddress_profileAddressCurrent__34KY0","itemValue":"CurrentAddress_itemValue__mIeCC"};